import { setApplicationState, resetApplicationState } from './application/actions';
import { setCalculateState, resetCalculateState } from './calculate/actions';
import { setDesignState, resetDesignState } from './design/actions';
import { setDimensionState, resetDimensionState } from './dimension/actions';
import { setEditorState, resetEditorState } from './editor/actions';
import { setLoadsState, resetLoadsState } from './loads/actions';
import { setMaterialState, resetMaterialState } from './material/actions';

export function setSelectorsState(state) {
  return dispatch => {
    dispatch(setApplicationState(state.application));
    dispatch(setCalculateState(state.calculate));
    dispatch(setDesignState(state.design));
    dispatch(setDimensionState(state.dimension));
    dispatch(setEditorState(state.editor));
    dispatch(setLoadsState(state.loads));
    dispatch(setMaterialState(state.material));
  };
}

export function resetSelectorsState() {
  return dispatch => {
    dispatch(resetApplicationState());
    dispatch(resetCalculateState());
    dispatch(resetDesignState());
    dispatch(resetDimensionState());
    dispatch(resetEditorState());
    dispatch(resetLoadsState());
    dispatch(resetMaterialState());
  };
} 



// WEBPACK FOOTER //
// ./src/reducers/selectors/actions.js